import {Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute, Data, Router} from "@angular/router";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {TreoMediaWatcherService} from "@treo/services/media-watcher";
import {TreoNavigationService} from "@treo/components/navigation";
import {Usuarios} from "app/models/Usuario/usuarios.model";
import {TituloService} from "../../vertical/dense/titulo.service";
import {JogosService, TipoJogos} from "app/modules/admin/jogos/jogos.service";
import {Configuracoes} from "app/models/Configuracoes/configuracoes";

@Component({
	selector: "enterprise-layout",
	templateUrl: "./enterprise.component.html",
	styleUrls: ["./enterprise.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class EnterpriseLayoutComponent implements OnInit, OnDestroy {
	data: any;
	isScreenSmall: boolean;
	titulo: string = "";
	subtitulo: string = "";
	@HostBinding("class.fixed-header")
	fixedHeader: boolean;
	public configuracoes: Configuracoes = JSON.parse(localStorage.getItem("configuracoes"));
	@HostBinding("class.fixed-footer")
	fixedFooter: boolean;
	usuario: Usuarios = JSON.parse(localStorage.getItem("usuario"));
	// Private
	private _unsubscribeAll: Subject<any>;

	/**
	 * Constructor
	 *
	 * @param {ActivatedRoute} _activatedRoute
	 * @param {TreoMediaWatcherService} _treoMediaWatcherService
	 * @param {TreoNavigationService} _treoNavigationService
	 * @param {Router} _router
	 */
	constructor(
		private _activatedRoute: ActivatedRoute,
		private _treoMediaWatcherService: TreoMediaWatcherService,
		private _treoNavigationService: TreoNavigationService,
		public _router: Router,
		private tituloService: TituloService,
		private jogosService: JogosService,
	) {
		// Set the private defaults
		this._unsubscribeAll = new Subject();

		// Set the defaults
		this.fixedHeader = true;
		this.fixedFooter = true;
		this.tituloService.tituloAtual.subscribe((titulo) => (this.titulo = titulo));
		this.tituloService.subtituloAtual.subscribe((subtitulo) => (this.subtitulo = subtitulo));
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Accessors
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Getter for current year
	 */
	get currentYear(): number {
		return new Date().getFullYear();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */

	jogosAoVivo() {
		this.jogosService.dispararJogos(TipoJogos.AOVIVO);
	}

	jogosHoje() {
		this.jogosService.dispararJogos(TipoJogos.HOJE);
	}

	jogosAmanha() {
		this.jogosService.dispararJogos(TipoJogos.AMANHA);
	}

	jogosDepois() {
		this.jogosService.dispararJogos(TipoJogos.DEPOIS);
	}

	signOut(): void {
		localStorage.setItem("Ação", "Saiu");
		this._router.navigate(["/sign-out"]);
	}

	ngOnInit(): void {
		// Subscribe to the resolved route data
		this._activatedRoute.data.subscribe((data: Data) => {
			this.data = data.initialData;
		});

		// Subscribe to media changes
		this._treoMediaWatcherService.onMediaChange$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe(({matchingAliases}) => {
				// Check if the breakpoint is 'lt-md'
				this.isScreenSmall = matchingAliases.includes("lt-md");
			});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Toggle navigation
	 *
	 * @param key
	 */
	toggleNavigation(key): void {
		// Get the navigation
		const navigation = this._treoNavigationService.getComponent(key);

		if (navigation) {
			// Toggle the opened status
			navigation.toggle();
		}
	}

	diaDepois() {
		let diaDepoisDeAmanha = new Date();

		diaDepoisDeAmanha.setDate(diaDepoisDeAmanha.getDate() + 2);
		let dias = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
		return dias[diaDepoisDeAmanha.getDay()];
	}
}
